import React from "react";

import Breadcrumbs from "../new_template_common/breadcrumb/BreadCrumb";
import MobileFilterPanel from "./components/MobileFilterPanel";
import ListingPanel from "./components/ListingPanel";
import Filter from "./components/filter/filter";

import classes from "./css/lisitng.module.scss";
import { Helmet } from "react-helmet";
import CategoryDescription from "./components/catagory-description";
import ProductShimmer from "./components/ProductShimmer";
import FooterSeo from "../new_home_page/footer_seo/FooterSeo";
import useListing from "./useListing";

const Listing = (props) => {
  const {
    hitsPerPage,
    categorySlug,
    category,
    categoryError,
    shimmer,
    productShimmer,
    showModal,
    setShowModal,
    loadRange,
    setLoadRange,
    searchQuery,
    searchResults,
    totalProducts,
    totalPages,
    selectedPage,
    selectedFilters,
    setSelectedFilters,
    selectedRangeFilters,
    setSelectedRangeFilters,
    selectedSorting,
    setSelectedSorting,
    isMobile,
    isFetching,
    facetValues,
    facetStatsValues,
    rangeQuery,
    handlePageChange,
    loadNextPage,
    resetFilters,
  } = useListing(props);

  return (
    <main className={`site-main`}>
      <div className={classes.listin_page}>
        <Helmet>
          <title>
            {category.banner_title &&
              `Buy ${category.banner_title} Online in India | Sunny Diamonds`}
          </title>
          <meta
            name="description"
            content={`Buy ${category.banner_title} from Sunny Diamonds. Experience timeless elegance with our crafted and certified natural diamonds. ✓ 100% Certified Jewellery ✓ Easy Returns`}
          />
          <meta name="keywords" content={category.seo_keywords} />
          <meta property="og:site_name" content="Sunny Diamonds" />
          <meta property="og:type" content="Summary" />
          <meta property="og:title" content={category.seo_title} />
          <meta
            property="og:description"
            content={`Buy ${category.banner_title} from Sunny Diamonds. Experience timeless elegance with our crafted and certified natural diamonds. ✓ 100% Certified Jewellery ✓ Easy Returns`}
          />
          <meta property="og:url" content={window.location.href} />
          <meta name="twitter:card" content="Summary" />
          <meta name="twitter:site" content="@SunnyDiamond_4c" />
          <meta name="twitter:creator" content="Sunny Diamonds" />
          <meta name="twitter:title" content={category.seo_title} />
          <meta name="twitter:description" content={category.seo_description} />
          <link rel="canonical" href={window.location.href} />
        </Helmet>
        <div className="custom-container">
          <Breadcrumbs ancestor="Jewellery" current={props.match.params.id1} />
          <CategoryDescription
            categoryTitle={category.banner_title}
            categoryDescription={category.banner_content}
            categorySlug={props.match.params.id1 || props.match.path.replace(/^\//, "")}
            loading={!!categorySlug && !category.banner_title && !categoryError}
          />

          <MobileFilterPanel
            facetValues={facetValues}
            selectedFilters={selectedFilters}
            resetFilters={resetFilters}
            facetStatsValues={facetStatsValues}
            totalProducts={totalProducts}
            selectedRangeFilters={selectedRangeFilters}
            setSelectedRangeFilters={setSelectedRangeFilters}
            setSelectedFilters={setSelectedFilters}
            showModal={showModal}
            setShowModal={setShowModal}
            title={category.banner_title}
            categorySlug={props.match.params.id1 || props.match.path.replace(/^\//, "")}
            searchQuery={searchQuery}
            setSelectedSorting={setSelectedSorting}
            selectedSorting={selectedSorting}
            loadRange={loadRange}
            setLoadRange={setLoadRange}
          />

          <div className={classes.listing_wrap}>
            {(shimmer || totalProducts > 0 || Object.keys(selectedFilters).length > 0 || Object.keys(selectedRangeFilters).length > 0) && (
              <div className={classes.filter_wrap}>
                <Filter
                  facetValues={facetValues}
                  selectedFilters={selectedFilters}
                  resetFilters={resetFilters}
                  facetStatsValues={facetStatsValues}
                  selectedRangeFilters={selectedRangeFilters}
                  setSelectedRangeFilters={setSelectedRangeFilters}
                  setSelectedFilters={setSelectedFilters}
                  setShowModal={setShowModal}
                  searchQuery={searchQuery}
                  loadRange={loadRange}
                  setLoadRange={setLoadRange}
                  filterShimmer={shimmer}
                />
              </div>
            )}
            <div className={classes.product_wrap}>
              {shimmer ? (
                <ProductShimmer />
              ) : (
                <ListingPanel
                  products={searchResults}
                  title={category.banner_title}
                  description={category.banner_content}
                  history={props.history}
                  setSelectedSorting={setSelectedSorting}
                  selectedSorting={selectedSorting}
                  totalProducts={totalProducts}
                  selectedPage={selectedPage}
                  hitsPerPage={hitsPerPage}
                  handlePageChange={handlePageChange}
                  loadNextPage={loadNextPage}
                  isMobile={isMobile}
                  totalPages={totalPages}
                  productShimmer={productShimmer}
                  variantTag={
                    selectedFilters["variants.color"]
                      ? selectedFilters["variants.color"][0]
                      : null
                  }
                  isFetching={isFetching}
                  selectedFilters={selectedFilters}
                  setSelectedFilters={setSelectedFilters}
                  selectedRangeFilters={selectedRangeFilters}
                  setSelectedRangeFilters={setSelectedRangeFilters}
                  rangeQuery={rangeQuery}
                  resetFilters={resetFilters}
                />
              )}
            </div>
          </div>
        </div>
        {/* <div className="sticky-tag" /> */}
      </div>
      <FooterSeo />
    </main>
  );
};

export default Listing;
